import React from 'react';
import { injectIntl, intlShape } from 'react-intl';
// translate
import messages from './messages';

function Loading(props) {
  const { intl } = props;
  return (
    <div>
      <div className="error-404-wrap container-fluid dashboard-wrap">
        <div className="row">
          <div className="container">
            <div className="row">
              <div className="col-xs-12">
                <p className="error-404-text">
                  {intl.formatMessage(messages.pleaseWait)}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

Loading.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(Loading);



// WEBPACK FOOTER //
// ./src/components/Loading/index.js